export const getSelectedStaticPage = state => state.staticPages.selectedItem;
export const getStaticPageHeaderData = state => ({
  title: state.staticPages.selectedItem?.title || "",
  subtitle: state.staticPages.selectedItem?.subTitle || ""
});
export const getIsStaticPageLoading = state => state.staticPages.isItemFetching;
export const getStaticPageFetchErrorStatus = state =>
  state.staticPages.itemFetchErrorStatus;
